import React from 'react';
import { Page } from '../Page';
import { Logo } from '../Logo';
export function Page12() {
  return <Page hideFooter variant="dark" data-id="element-340">
      <div className="flex-1 flex items-center justify-center" data-id="element-341">
        <Logo className="w-[230px] h-[230px] object-contain opacity-90" data-id="element-342" />
      </div>
    </Page>;
}